import React from 'react';
import logoDEI from '../../static/images/logos/dei-logo.png';
import logoBridge from '../../static/images/logos/logo-bridge-no-text.png';

export const Titre = () => (
  <header className="flex flex-col md:flex-row justify-between items-center px-4">

    <a href="https://www.dei-belgique.be/"><img src={logoDEI} alt="logo DEI" className="w-44" /></a>

    <h1>
      <span className="uppercase text-3xl md:text-4xl px-0 md:px-2">Regards d&apos;enfants</span>
      <br />
      <span className="raleway md:text-xl">sur les violences basées sur le genre</span>
    </h1>
    <div className="w-44 flex justify-center md:justify-end">
      <a href="https://www.dei-belgique.be/index.php/projets/en-cours/bridge.html">
        <img src={logoBridge} alt="logo Bridge" className="w-28 h-28" />
      </a>
    </div>
  </header>
);
